import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-marque-and-category',
    templateUrl: './marque-and-category.component.html',
    styleUrls: ['./marque-and-category.component.scss']
})
export class MarqueAndCategoryComponent implements OnInit {
    activeTab: string = 'catégorie';

    constructor() {}

    ngOnInit(): void {
        console.log('MarqueAndCategoryComponent initialized');
    }

    setActiveTab(tab: string) {
        if (tab === 'catégorie' || tab === 'unité' || tab === 'marque') {
            this.activeTab = tab;
          //  console.log('Active tab set to:', tab);
        }
    }
}
